export default [
  {
    value: 'ADD_REVIEW',
    label: 'Add review',
    category: 'REVIEWERS',
  },
];
